import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  atualizarFonteTribunal,
  fetchFontesTribunais,
  type AtualizarFonteTribunalInput,
  type FonteTribunal,
} from '../api/fontesTribunais';

const QUERY_KEY = ['admin', 'fontes-tribunais'] as const;

export function useFontesTribunais() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchFontesTribunais,
  });
}

export function useAtualizarFonteTribunal() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ idFonte, input }: { idFonte: string; input: AtualizarFonteTribunalInput }) =>
      atualizarFonteTribunal(idFonte, input),
    onSuccess: (fonte) => {
      // A resposta já é a fonte gravada: troca a linha sem reler a lista inteira.
      queryClient.setQueryData<FonteTribunal[]>(QUERY_KEY, (atual) =>
        atual?.map((f) => (f.id_fonte === fonte.id_fonte ? fonte : f)),
      );
    },
  });
}
